/**
 * Blog, chatbot, notes, PDF, document actions
 */
export const BLOG_ACTIONS = {
  ARTICLE_VIEWED: 'article_viewed',
  CATEGORY_FILTER: 'category_filter',
  TAG_FILTER: 'tag_filter',
  SEARCH_PERFORMED: 'search_performed',
  ARTICLE_SHARED: 'article_shared',
  LOAD_MORE: 'load_more',
} as const;

export const CHATBOT_ACTIONS = {
  CHAT_OPENED: 'chat_opened',
  CHAT_CLOSED: 'chat_closed',
  MESSAGE_SENT: 'message_sent',
  CHAT_CLEARED: 'chat_cleared',
  SUGGESTED_QUESTION_CLICKED: 'suggested_question_clicked',
  FEEDBACK_GIVEN: 'feedback_given',
} as const;

export const NOTES_ACTIONS = {
  PANEL_OPENED: 'panel_opened',
  PANEL_CLOSED: 'panel_closed',
  NOTE_CREATED: 'note_created',
  NOTE_EDITED: 'note_edited',
  NOTE_SAVED: 'note_saved',
  NOTE_DELETED: 'note_deleted',
  NOTE_SELECTED: 'note_selected',
  FOLDER_CREATED: 'folder_created',
} as const;

export const PDF_ACTIONS = {
  GENERATION_STARTED: 'generation_started',
  GENERATION_SUCCESS: 'generation_success',
  GENERATION_FAILED: 'generation_failed',
  DOWNLOADED: 'downloaded',
  SECTION_SELECTED: 'section_selected',
} as const;

export const DOCUMENT_ACTIONS = {
  VIEWED: 'viewed',
  DOWNLOADED: 'downloaded',
} as const;
